/**
* Created by vouill on 6/2/18.
*/

<template>
  <div class="v-content-display">
    <loading v-if="status === 'loading'"/>
    <div
      v-else
    >
      <div class="title has-text-centered">{{ data.items && data.items[0].fields.title }}</div>
      <div class="content"><v-showdown
        :source="data.items && data.items[0].fields.content" />
    </div></div>
  </div>
</template>

<script>
import { actions, getApiData, getApiStatus } from "vuex-api";
import { mapState } from "vuex";
export default {
  name: "Equipe",
  created: function() {
    this.$store.dispatch(actions.request, {
      requestConfig: {
        baseURL: "https://cdn.contentful.com",
        headers: {
          Authorization:
            "Bearer a668f1bb4d9f2c93e9f6f4dfa8954ea8a1ae452c1a1cfb354293df81f08895e9"
        }
      },
      method: "GET",
      url: "spaces/uhuxxitrg1zr/entries",
      params: {
        content_type: "simplePage",
        "fields.slug": "contact",
        include: 3
      },
      keyPath: `contact` // Will set the namespace where it will be stored in the vuex state
    });
  },
  computed: mapState({
    data: getApiData("contact"),
    status: getApiStatus("contact")
  })
};
</script>
